import React, { useState } from 'react';
import classnames from "classnames";
import { Form, ModalBody, Col, Row, ModalFooter, Button, NavItem, Nav, NavLink, Card, TabContent, TabPane, CardBody, CardSubtitle, Input, Label, FormGroup, InputGroupAddon, InputGroupText, FormFeedback, Media, FormText } from 'reactstrap';
import preview from '../../assets/images/appointment/app-ent.jpg';
import './styleSucursales.css';
import { TabMenu } from 'primereact/tabmenu';


export const FormBranch = (props) => {

    const {
        toggle, loading,
        handleInputChange, validaciones, methodAction,
        id_commercial_line, name, code, number_phone, email, id_state, id_municipality,
        address, colony, cp, url, logo, name_responsible, certificate, image_firm, toma,
        imageLogo, imageFirm, imageBackground,
        button,
        states, municipalities, commercialLines,
        handleChangeState,
        previewLogo, previewFirm, previewBackground,
        imageHandler,roleUser_responsible
    } = props;

    const {
        id_commercial_line_valid,
        code_valid,
        name_valid,
        number_phone_valid,
        email_valid,
        id_state_valid,
        id_municipality_valid,
        address_valid,
        colony_valid,
        cp_valid,
        name_responsible_valid,
        certificate_valid,roleUser_responsible_valid
    } = validaciones;

    const [activeTab, setActiveTab] = useState(1);

    const toggleTab = tab => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    const [activeIndex, setActiveIndex] = useState(0);

    const items = [
        { label: 'Datos generales' },
        { label: 'Responsable de resultados' }
    ];

    return (
        <Form className="form theme-form" role="form" onSubmit={methodAction}>
            
                <div>
                
                    <TabMenu 
                        model={items} 
                        activeIndex={activeIndex} 
                        onTabChange={(e) => setActiveIndex(e.index)}
                        className="custom-tabmenu-blue-report"

                    />


                </div>
                        {activeIndex === 0 && (
                            <Card className="cardCompact shadow-sm border-0">

                                <CardBody className="p-3">

                                    <Row className="g-2 align-items-center">

                                        <Col xxl="2" xl="2" lg="2" md="3" sm="12" className="text-center">

                                            <Label htmlFor="logo" className="mb-0 pointerCursor">

                                                <Media
                                                    body
                                                    src={
                                                        ((imageLogo !== undefined && imageLogo !== null) && previewLogo === "")
                                                            ? "data:image/png;base64," + imageLogo
                                                            : (previewLogo === "")
                                                                ? require('../../assets/images/user/16.png')
                                                                : previewLogo
                                                    }
                                                    alt="#"
                                                    className="imgLogoCompact"
                                                />

                                                <Input
                                                    type="file"
                                                    id="logo"
                                                    name="logo"
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    style={{ display: 'none' }}
                                                    onChange={imageHandler}
                                                />

                                            </Label>

                                        </Col>

                                        <Col xxl="10" xl="10" lg="10" md="9" sm="12">

                                            <Row className="g-2">

                                                <Col md="6">
                                                    <Label className="labelCompact">
                                                        Nombre de la sucursal
                                                    </Label>

                                                    <Input
                                                        type="text"
                                                        name="name"
                                                        onChange={handleInputChange}
                                                        value={name}
                                                        className="inputCompact"
                                                        autoComplete='off'
                                                        disabled
                                                    />
                                                </Col>

                                                <Col md="3">
                                                    <Label className="labelCompact">
                                                        Código
                                                    </Label>

                                                    <Input
                                                        className="inputCompact"
                                                        autoComplete="off"
                                                        type="number"
                                                        name="code"
                                                        onChange={handleInputChange}
                                                        value={code}
                                                    />
                                                </Col>

                                                <Col md="3">
                                                    <Label className="labelCompact">
                                                        Código Postal
                                                    </Label>

                                                    <Input
                                                        disabled
                                                        type="number"
                                                        name="cp"
                                                        value={cp}
                                                        className="inputCompact"
                                                    />
                                                </Col>

                                                <Col md="6">
                                                    <Label className="labelCompact">
                                                        Razón Social
                                                    </Label>

                                                    <Input
                                                        disabled
                                                        type="select"
                                                        className="inputCompact"
                                                        name="id_commercial_line"
                                                        value={id_commercial_line}
                                                        onChange={handleInputChange}
                                                    >
                                                        <option value={0}>
                                                            Selecciona una opción
                                                        </option>

                                                        {
                                                            commercialLines.length >= 1 &&
                                                            commercialLines.map((obj, key) => (
                                                                <option
                                                                    key={key}
                                                                    value={obj.id_commercial_line}
                                                                >
                                                                    {obj.long_name}
                                                                </option>
                                                            ))
                                                        }
                                                    </Input>
                                                </Col>

                                                <Col md="6">
                                                    <Label className="labelCompact">
                                                        Teléfonos
                                                    </Label>

                                                    <Input
                                                        type="text"
                                                        autoComplete="off"
                                                        name="number_phone"
                                                        onChange={handleInputChange}
                                                        value={number_phone}
                                                        className="inputCompact"
                                                        disabled
                                                    />
                                                </Col>

                                            </Row>

                                        </Col>

                                    </Row>

                                    <div className="sectionCompact mt-3">

                                        <Row className="g-2 align-items-end">

                                            <Col lg="3" md="6">
                                                <Label className="labelCompact">
                                                    Estado
                                                </Label>

                                                <select
                                                    disabled
                                                    value={id_state}
                                                    name="id_state"
                                                    className="form-control inputCompact"
                                                    onChange={handleChangeState}
                                                >
                                                    <option value="-1">
                                                        Selecciona una opción
                                                    </option>

                                                    {
                                                        states.length > 0 &&
                                                        states.map((s, key) => (
                                                            <option
                                                                key={key}
                                                                value={s.id_state}
                                                            >
                                                                {s.name}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </Col>

                                            <Col lg="3" md="6">
                                                <Label className="labelCompact">
                                                    Municipio
                                                </Label>

                                                <select
                                                    disabled
                                                    value={id_municipality}
                                                    name="id_municipality"
                                                    className="form-control inputCompact"
                                                    onChange={handleInputChange}
                                                >
                                                    <option value="-1">
                                                        Selecciona una opción
                                                    </option>

                                                    {
                                                        municipalities.length > 0 &&
                                                        municipalities.map((m, key) => (
                                                            <option
                                                                key={key}
                                                                value={m.id_municipality}
                                                            >
                                                                {m.name}
                                                            </option>
                                                        ))
                                                    }
                                                </select>
                                            </Col>

                                            <Col lg="3" md="6">
                                                <Label className="labelCompact">
                                                    Colonia
                                                </Label>

                                                <Input
                                                    disabled
                                                    type="text"
                                                    name="colony"
                                                    value={colony}
                                                    className="inputCompact"
                                                />
                                            </Col>

                                            <Col lg="3" md="6">
                                                <Label className="labelCompact">
                                                    Dirección
                                                </Label>

                                                <Input
                                                    disabled
                                                    type="text"
                                                    name="address"
                                                    value={address}
                                                    className="inputCompact"
                                                />
                                            </Col>

                                        </Row>

                                    </div>

                                    <div className="sectionCompact mt-3">

                                        <Row className="g-2 align-items-center">

                                            <Col lg="4" md="6">
                                                <Label className="labelCompact">
                                                    Correo electrónico
                                                </Label>

                                                <Input
                                                    disabled
                                                    type="email"
                                                    name="email"
                                                    value={email}
                                                    className="inputCompact"
                                                />
                                            </Col>

                                            <Col lg="4" md="6">
                                                <Label className="labelCompact">
                                                    Sitio web
                                                </Label>

                                                <Input
                                                    type="text"
                                                    name="url"
                                                    onChange={handleInputChange}
                                                    value={url}
                                                    className="inputCompact"
                                                />
                                            </Col>

                                            {/* SWITCH */}
                                            <Col lg="2" md="6" sm="6" className="text-center">

                                                <Label className="labelCompact d-block">
                                                    Toma muestra
                                                </Label>

                                                <Label className="switch mb-0">
                                                    <Input
                                                        type="checkbox"
                                                        name="toma"
                                                        onChange={handleInputChange}
                                                        checked={toma}
                                                    />
                                                    <span className="slider round"></span>
                                                </Label>

                                            </Col>

                                            <Col lg="2" md="6" sm="6" className="text-center">

                                                <Label
                                                    htmlFor="background_image"
                                                    className="mb-0 pointerCursor"
                                                >

                                                    <Media
                                                        body
                                                        src={
                                                            ((imageBackground !== undefined && imageBackground !== null) && previewBackground === "")
                                                                ? "data:image/png;base64," + imageBackground
                                                                : (previewBackground === "")
                                                                    ? require('../../assets/images/user/16.png')
                                                                    : previewBackground
                                                        }
                                                        alt="#"
                                                        className="imgBackgroundCompact"
                                                    />

                                                    <Input
                                                        type="file"
                                                        id="background_image"
                                                        name="background_image"
                                                        style={{ display: 'none' }}
                                                        accept="image/*"
                                                        onChange={imageHandler}
                                                    />

                                                </Label>

                                            </Col>

                                        </Row>

                                    </div>

                                </CardBody>

                            </Card>
                        )}
                        
                        {activeIndex === 1 && (
                            <Card className="shadow-sm border-0 cardResponsible">
                                <CardBody className="p-4">

                                    <div className="text-center mb-4">
                                        <h4 className="titleResponsible mb-1">
                                            Responsable de Resultados
                                        </h4>

                                        <p className="text-muted mb-0">
                                            Información y firma del responsable
                                        </p>
                                    </div>

                                    <Row className="align-items-center">

                                        <Col xl="3" lg="4" md="12" className="text-center mb-4 mb-lg-0">

                                            <Label
                                                htmlFor="image_firm"
                                                className="uploadFirmContainer"
                                            >
                                                <div className="uploadCircle">

                                                    <Media
                                                        body
                                                        src={
                                                            ((imageFirm !== undefined && imageFirm !== null) && previewFirm === "")
                                                                ? "data:image/png;base64," + imageFirm
                                                                : (previewFirm === "")
                                                                    ? require('../../assets/images/user/16.png')
                                                                    : previewFirm
                                                        }
                                                        alt="#"
                                                        className="imgFirm"
                                                    />

                                                </div>

                                                <div className="mt-3">
                                                    <span className="btnUploadFirm">
                                                        Cambiar firma
                                                    </span>
                                                </div>

                                                <Input
                                                    type="file"
                                                    id="image_firm"
                                                    name="image_firm"
                                                    style={{ display: 'none' }}
                                                    accept="image/*"
                                                    onChange={imageHandler}
                                                />
                                            </Label>

                                        </Col>

                                        <Col xl="9" lg="8" md="12">

                                            <Row>

                                                <Col md="6" xl="4" className="mb-3">
                                                    <Label className="labelResponsible">
                                                        Nombre del responsable
                                                    </Label>

                                                    <Input
                                                        className="inputResponsible"
                                                        type="text"
                                                        name="name_responsible"
                                                        onChange={handleInputChange}
                                                        invalid={name_responsible_valid}
                                                        value={name_responsible}
                                                        autoComplete='off'
                                                        placeholder="Ingrese nombre completo"
                                                    />

                                                    <FormFeedback>
                                                        El campo debe tener 3 o más caracteres
                                                    </FormFeedback>
                                                </Col>

                                                <Col md="6" xl="4" className="mb-3">
                                                    <Label className="labelResponsible">
                                                        Cédula profesional
                                                    </Label>

                                                    <Input
                                                        className="inputResponsible"
                                                        type="text"
                                                        name="certificate"
                                                        onChange={handleInputChange}
                                                        invalid={certificate_valid}
                                                        value={certificate}
                                                        autoComplete='off'
                                                        placeholder="Ingrese cédula"
                                                    />

                                                    <FormFeedback>
                                                        El campo debe tener 3 o más caracteres
                                                    </FormFeedback>
                                                </Col>

                                                <Col md="12" xl="4" className="mb-3">
                                                    <Label className="labelResponsible">
                                                        Puesto que ocupa
                                                    </Label>

                                                    <Input
                                                        className="inputResponsible"
                                                        type="text"
                                                        name="roleUser_responsible"
                                                        onChange={handleInputChange}
                                                        invalid={roleUser_responsible_valid}
                                                        value={roleUser_responsible}
                                                        autoComplete='off'
                                                        placeholder="Ingrese puesto"
                                                    />

                                                    <FormFeedback>
                                                        El campo debe tener 3 o más caracteres
                                                    </FormFeedback>
                                                </Col>

                                            </Row>

                                        </Col>

                                    </Row>

                                </CardBody>
                            </Card>
                        )}
               
            
        </Form>
    )
}
